import { useState } from "react";
import { toast } from "react-toastify";
import PageHeader from "../../Component/PageHeader";
import Pill from "../../Component/Pill";
import { ADMINS, PERMISSION_MATRIX, PERMISSION_MODULES, ROLE_NAMES, initials } from "../../utils/staticData";

// STATIC DESIGN — members & permissions live in local state until the admin-roles API exists
const AdminTeam = () => {
  const [matrix, setMatrix] = useState<number[][]>(PERMISSION_MATRIX.map(r => [...r]));
  const [dirty, setDirty] = useState(false);

  const toggle = (role: number, mod: number) => {
    setMatrix(m => m.map((r, j) => (j === role ? r.map((v, i) => (i === mod ? (v ? 0 : 1) : v)) : r)));
    setDirty(true);
  };

  const save = () => {
    setDirty(false);
    toast.success("Permissions saved");
  };

  return (
    <div className="container-fluid">
      <div className="cx">
        <PageHeader
          crumb="Admin & roles"
          title="Admin team & roles"
          sub="UOMOX staff who use this panel — completely separate from client agents."
          actions={<button type="button" className="cx-btn cx-btn-primary" onClick={() => toast.success("Invite sent")}><i className="ri-user-add-line"></i>Invite admin</button>}
        />

        <div className="cx-grid g12">
          <div className="cx-card">
            <div className="cx-card-h"><h6>Members</h6><span className="sub">2FA enforced</span></div>
            <div className="cx-card-b">
              {ADMINS.map(([name, email, role, seen]) => (
                <div className="cx-orow" key={email}>
                  <div className="cx-who">
                    <div className="av">{initials(name)}</div>
                    <div style={{ minWidth: 0 }}><b>{name}</b><small>{email}</small></div>
                  </div>
                  <div className="right" style={{ flexDirection: "column", alignItems: "flex-end", gap: 3 }}>
                    <Pill tone={role === "Super Admin" ? "blue" : "none"}>{role}</Pill>
                    <span className="fs12 muted">{seen}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="cx-card">
            <div className="cx-card-h">
              <h6>Role permissions</h6>
              <button type="button" className="cx-btn cx-btn-light cx-btn-xs" onClick={() => toast.info("New role drafted")}><i className="ri-add-line"></i>New role</button>
            </div>
            <div className="cx-tbl-wrap">
              <table className="cx-tbl center">
                <thead>
                  <tr><th>Permission</th>{ROLE_NAMES.map(r => <th key={r}>{r}</th>)}</tr>
                </thead>
                <tbody>
                  {PERMISSION_MODULES.map((mod, i) => (
                    <tr key={mod}>
                      <td style={{ fontSize: 13 }}>{mod}</td>
                      {ROLE_NAMES.map((role, j) => (
                        <td key={role}>
                          <input
                            type="checkbox"
                            aria-label={`${role} · ${mod}`}
                            checked={!!matrix[j][i]}
                            disabled={j === 0}
                            onChange={() => toggle(j, i)}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="cx-tfoot">
              <span>Super Admin permissions are locked.</span>
              <button type="button" className="cx-btn cx-btn-primary cx-btn-sm" disabled={!dirty} onClick={save}>Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminTeam;
